let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9WKd2")).then(() => parcelRequire('gaGnN'));